import React, { useEffect, useState } from "react";
import scheduleService from "../../../services/schedule.service";
import ListSchedule from "../listSchedule";

const DashboardTqf = () => {
  const [schedule, setSchedule] = useState([]);
  //เช็กว่ามีกำหนดการ มคอ เปิดรับเอกสารไหม ถ้าเปิดให้ list รายการกำหนดการที่เปิดรับ ถ้าไม่ แสดงข้อความว่าไม่มีเอกสารที่ต้องส่ง
  //get schedule where status = true and type = tqf  ยิงไปที่นี่ http://localhost:5500/api/schedule/tqf
  useEffect(() => {
    (async () => {
      //ดำเนินการตรงนี้
      const scheduleTqf = await scheduleService
        .getScheduleOpenForSend("tqf")
        .then((res) => res.data);
      if (scheduleTqf.length > 0) {
        setSchedule(scheduleTqf);
      }
    })();
  }, []);
  if (schedule.length <= 0) {
    return <></>;
  }

  return (
    <div className="alert alert-primary text-dark" role="alert">
      <h3 className="mt-2 bg-white rounded-pill p-2">
        <strong>กำหนดส่ง มคอ. | RMUTI</strong>{" "}
      </h3>
      {/* <h1 className="mt-2 text-danger mt-3">
          <i className="bi bi-folder-x"></i> ยังไม่มีกำหนดการที่ต้องส่งเอกสาร
        </h1> */}
      {/* ตรงนี้ต่องส่ง schedule ไป ListSchedule ด้วย */}
      <div className="container mt-4">
        <div className="row row-cols-1 row-cols-md-4  g-4 text-end justify-content-center align-items-center">
          {schedule.map((schedule: any) => {
            return (
              <ListSchedule key={schedule.id} type="มคอ." schedule={schedule} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardTqf;
